const NS = 'CareerListingPage';
const CLS = 'careerListingPage';

import * as Api from '../../../../global/js/api';
import { initPagination } from '../../../../global/js/pagination';
import Handlebars from 'handlebars';

export class CareerListingPage {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.pageSize = this.$element.data('pageSize');
		this.sourceId = this.$element.data('sourceId');
		this.getApi = this.$element.data('getApi');

		this.params = {
			sourceId: this.sourceId,
			pageNumber: 1,
			pageSize: this.pageSize
		};

		this.loadingSpinner = $('.loading-spinner');
		this.$itemsList = this.$element.find(`.tpl-content-list`);
		this.$pagination = this.$element.find(`.tpl-content-pagination`);
		this.setItemTemplate();
		this.getItems();

		this.$element.on('pagination.trigger', () => {
			this.getItems(true);
		});
	}

	getItems(scrollToTop = false) {
		let url = this.getApi;

		if(!_.isEmpty(this.params)) {
			url += `?${$.param(this.params)}`;
		}

		this.$itemsList.empty();
		this.loadingSpinner.addClass('is-active');

		Api.getApi(url).then((data) => {
			let items = data.results;
			if(items.length > 0) {
				items.forEach((item) => {
					let itemMarkup = this.itemTemplate(item);
					this.$itemsList.append(itemMarkup);
				});

				if(scrollToTop) {
					this.$element.trigger('pagination.scrollToTop');
				}

				initPagination(this.pageSize, data.totalCount, this.$pagination, this);
			}
			else {
				this.$itemsList.html(this.getEmptyResultTemplate());
			}

			this.loadingSpinner.removeClass('is-active');
		}, () => {
			this.loadingSpinner.removeClass('is-active');
		});
	}

	setItemTemplate() {
		let careerItemPartial = require('../../../widgets/careerListingItemWidget/tmpl/careerListingItemWidget.hbs');
		Handlebars.registerPartial('careerListingItemWidget', careerItemPartial);

		let template = `
			{{> careerListingItemWidget
				wg="careerListingItemWidget"
				ns="CareerListingItemWidget"
			}}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		this.itemTemplate = Handlebars.template(precompiled);
	}

	getEmptyResultTemplate() {
		return `<p class="${CLS}-emptyResult">Sorry, no available positions found.</p>`;
	}
}
